<template>
  <div class="newsDetail TopHeadder">
      <div class="bannerBox">
          <img :src="'https://www.xiaoyu168.com/'+$store.state.newsdetail.detailData.PicturePath" />
      </div>
      <div class="PublicPadding">
          <h4 class="title" v-text="$store.state.newsdetail.detailData.Title">应用场景</h4>
          <p class="time" v-text="$store.state.newsdetail.detailData.AddTime2"></p>
          <div class="textBox" v-html="$store.state.newsdetail.detailData.HtmlContent"></div>
          <div class="jumpBox">
            <div>
              <a href="javascript:;" @click="Jump($store.state.newsdetail.detailData.PrevID)" v-if="$store.state.newsdetail.detailData.PrevID">
                上一篇：<span v-text="$store.state.newsdetail.detailData.PrevTitle"></span>
              </a>
            </div>
            <div>
              <a href="javascript:;" @click="Jump($store.state.newsdetail.detailData.NextID)" v-if="$store.state.newsdetail.detailData.NextID"> 
                下一篇：<span v-text="$store.state.newsdetail.detailData.NextTitle"></span>
              </a>
            </div>
          </div>
      </div>
       <Popup v-show="$store.state.isshow"></Popup>
  </div>
</template>

<script>
import Popup from "@/components/popup"
export default {
  name: 'newsDetail',
  data () {
    return {
      
    }
  },
  components:{
      Popup
  },
  methods:{
    popup(){
       this.$store.commit("openPop",{isopen:true,type:1})
    },
    Jump(id){
      //debugger
      //return;
      this.$router.push('/newsDetail/'+id);
      this.$store.commit("newsDetail",id);
    }
  },
  mounted(){ 
      //console.log(this.$route.params.mId)
      this.$store.commit("newsDetail",this.$route.params.mId);
  }
}
</script>


<style scoped>
.title{
  font-size: 18px;
  font-weight: bold;
}
.time{
  text-align: center;
  color: #999;
  font-size: 14px;
  line-height: 20px;
  margin-top: 0.1rem;
}
.textBox{
  padding: 0 0.2rem;
  margin-top: 0.2rem;
}

.jumpBox{
  margin-top: 0.4rem;
  font-size: 14px;
  padding: 0 0.2rem;
}
.jumpBox div{
  padding: 0.1rem;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space:nowrap
}
</style>



// WEBPACK FOOTER //
// src/components/news/detail.vue